import React from 'react'
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import SessionExpiredModal from '../../components/SessionExpiredModal';

const AppProvider = ({ children }) => {
  return (
    <>
      <SessionExpiredModal />
      {children}
      <ToastContainer
        theme="colored"
        position="bottom-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default AppProvider;
